import { SalaryInfo } from './ui';

export { SalaryInfo };
